function screen_selected(sender, type, id) {
    var $ = jQuery.noConflict();
    var elm = $(sender);

    var selection = [];
    var eq = elm.parents('td').index();
    var tbody = elm.parents('tbody');
    tbody.children('tr').each(function() {
        var input = $(this).children('td:eq('+eq+')').children('input');
        if(input.is(':checked')) {
            selection.push(input.val());
        }
    });

    window['selected_'+type] = selection;

    if(selection.length > 0) {
        $('.screen-buttons-container').trigger('showScreenSelectionButtons');
    } else {
        $('.screen-buttons-container').trigger('hideScreenSelectionButtons');
    }
    return false;
}
